module.exports = __webpack_public_path__ + "img/lg-redotpay.2108be0b.svg";